import React from "react";
import Uniramp from "Pages/Uniramp";

const UnirampTheme = () => {
  return (
    <React.Fragment>
      <Uniramp />
    </React.Fragment>
  );
};

export default UnirampTheme;
